import { useEffect, useState } from 'react';

/**
 * Subscribe to a periodic tick. Returns the current `Date.now()` value and
 * triggers a re-render every `intervalMs`. Use for live countdowns or any
 * UI that depends on the current wall-clock time.
 *
 * Uses the device's clock — countdowns are off by however much the device
 * is skewed from real UTC. For most consumer apps this is acceptable. If
 * we need precise countdowns, switch to a server-supplied `now` baseline.
 */
export function useNow(intervalMs: number = 1000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return now;
}
